import {useContext} from 'react'
import {EffectivePermissionsContext} from "../context/EffectivePermissionsContextProvider";

export function useEffectivePermissionsContext()
{
    const context = useContext(EffectivePermissionsContext);

    if (!context) {
        throw new Error(
            "useEffectivePermissionsContext must be used within the scope of EffectivePermissionsContext"
        );
    }

    return context;
}